"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const styled_components_1 = require("styled-components");

const theme_1 = require("./theme");

const WorthyThemeProvider = ({
  children,
  isMobile = false
}) => {
  return (0, jsx_runtime_1.jsx)(styled_components_1.ThemeProvider, Object.assign({
    theme: { ...theme_1.mainTheme,
      isMobile
    }
  }, {
    children: children
  }), void 0);
};

exports.default = WorthyThemeProvider;